import { render, staticRenderFns } from "./SaleMali.vue?vue&type=template&id=7a9f6080&"
import script from "./SaleMali.vue?vue&type=script&lang=js&"
export * from "./SaleMali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports